import React, {useState} from 'react';
import {Button, Grid, InputBase, InputLabel, makeStyles,} from '@material-ui/core';
import Typography from "@material-ui/core/Typography";
import {sendFormResult} from "@cabinet-packages/api/api";

const useStyles = makeStyles((theme) => ({
  rootContainer: {
    width: '100%',
    maxWidth: '900px',
    padding: '0 10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  headerLabel: {
    color: theme.palette.primary.dark,
  },
  extraLabel: {
    color: theme.palette.primary.main,
    margin: '10px 0px 20px 0px'
  },
  inputRoot: {
    padding: '5px 5px 5px 10px',
    border: `1px solid #e8e8e8`,
    borderRadius: '5px',
    height: '40px',
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      display: "none",
    },
    "& input[type=number]": {
      MozAppearance: "textfield",
    },
  },
  inputLabel: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '12px',
    margin: '10px'
  },
  submitBtnContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '20px'
  }
}));

const CabinetSupport = () => {
  const classes = useStyles()
  const [{ firstname, lastname, phone, mail, question, l, thanks }, setUserData] = useState({
    firstname: "",
    lastname: '',
    mail: '',
    phone: "",
    question: "",
    checkbox: false,
    l: false,
    thanks: false
  })

  const sendForm = async () => {

    try {
      setUserData({
        l: true
      });
      await sendFormResult(firstname, lastname, phone.replace(/\D/g,''), mail, question);
      setUserData({
        thanks: true,
        firstname: "",
        lastname: '',
        mail: '',
        phone: "",
        question: "",
        checkbox: false,
        l: false
      });
    } catch (e) {
      console.error(e)
      setUserData({
        l: false
      });
      console.log("sendFormResult error", e.message);
    }
  }

  const handleChange = e => {
    e.persist()
    if (!e || !e.target) return

    setUserData(p=>({
      ...p,
      [e.target.name]: e.target.value
    }))
  }

  return (
    <div className={classes.rootContainer}>
      <div>
        <Typography color={"textPrimary"} variant={'h4'} className={classes.headerLabel}>
          Служба підтримки
        </Typography>
        <Typography className={classes.extraLabel}>
          {thanks ? 'Дякуємо, Ваше звернення важливе для нас!' : 'Залиште ваше повідомлення'}
        </Typography>
      </div>
      {!thanks && <Grid container spacing={3}>
        <Grid item xs={6}>
          <InputLabel className={classes.inputLabel}>Прізвище</InputLabel>
          <InputBase
              variant="standard"
              name='lastname'
              className={classes.inputRoot}
              fullWidth
              onChange={handleChange}

          />
        </Grid>
        <Grid item xs={6}>
          <InputLabel className={classes.inputLabel}>Ім'я</InputLabel>
          <InputBase
              variant="standard"
              name='firstname'
              className={classes.inputRoot}
              fullWidth
              onChange={handleChange}

          />
        </Grid>
        <Grid item xs={6}>
          <InputLabel className={classes.inputLabel}>Контактний телефон</InputLabel>
          <InputBase
              defaultCountry='ua'
              type="number"
              name='phone'
              countryCodeEditable={false}
              fullWidth={true}
              disableDropdown={true}
              InputProps={{disableUnderline: true}}
              className={classes.inputRoot}
              onChange={handleChange}

          />
        </Grid>
        <Grid item xs={6}>
          <InputLabel className={classes.inputLabel}>Електронна пошта</InputLabel>
          <InputBase
              variant="standard"
              name='mail'
              className={classes.inputRoot}
              fullWidth
              onChange={handleChange}

          />
        </Grid>
        <Grid item xs={12}>
          <InputLabel className={classes.inputLabel}>Опис</InputLabel>
          <InputBase
              variant="standard"
              name='question'
              className={classes.inputRoot}
              style={{height: '100px'}}
              fullWidth
              multiline
              rows={4}
              onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} className={classes.submitBtnContainer}>
          <Button
              color={'primary'}
              variant="contained"
              onClick={sendForm}
              disabled={!mail || !firstname || !lastname || !phone || !question || l}
          >
            НАДІСЛАТИ
          </Button>
        </Grid>
      </Grid>}
    </div>
  );
}

export default CabinetSupport